"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitySlideout = void 0;
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const JuvareTheme_1 = require("@juvare/common-web-ui/JuvareTheme");
const ModalSlideout_1 = require("@juvare/common-web-ui/ModalSlideout");
const NavigationContext_1 = require("@juvare/common-web-ui/NavigationContext");
const PartialError_1 = require("@juvare/common-web-ui/PartialError");
const hooks_1 = require("../../../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const EntitySlideoutContent_1 = require("./EntitySlideoutContent");
const entitySlideoutDetailsId_1 = require("./entitySlideoutDetailsId");
function EntitySlideout(props) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const navigationContext = react_1.default.useContext(NavigationContext_1.NavigationContext);
    const navigate = (0, react_router_1.useNavigate)();
    const { data, isLoading, error } = (0, hooks_1.useStorageGet)(props.entity, props.id);
    const storage = (0, hooks_1.useStorageClient)(props.entity);
    const menuItems = [];
    if ((data === null || data === void 0 ? void 0 : data.columns.defaultName) != null) {
        menuItems.push({
            label: t('classifiers.resetToDefaultValues'),
            onClick: () => {
                if (data) {
                    (0, DialogHelper_1.showConfirmDialog)({
                        title: t('classifiers.resetItemToDefaultValues', { item: props.getEntityTitle(data) }),
                        onConfirm: () => {
                            var _a;
                            if (data) {
                                storage
                                    .post({
                                    action: 'update',
                                    id: data.id,
                                    data: Object.assign(Object.assign(Object.assign({}, data.data), data.data.default), { form: (_a = data.data.default) === null || _a === void 0 ? void 0 : _a.form }),
                                })
                                    .then(() => props.onClose(true))
                                    .catch(DialogHelper_1.handleErrorDialog);
                            }
                        },
                    });
                }
            },
        });
    }
    return (react_1.default.createElement(ModalSlideout_1.ModalSlideout, { ariaContentId: entitySlideoutDetailsId_1.entitySlideoutDetailsId, open: !!props.id, onClose: () => props.onClose(false), "data-test": 'classifier-entity-slideout' },
        react_1.default.createElement(material_1.Box, { sx: {
                overflow: 'auto',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: JuvareTheme_1.themeColors.surface.primary,
            } },
            data && !error && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ModalSlideout_1.ModalSlideoutTopBar, { isOpaque: true },
                    react_1.default.createElement(ModalSlideout_1.ModalSlideoutTopBarDefaultActions, { onClose: () => props.onClose(false), menuItems: props.hideCreate ? undefined : menuItems })),
                react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'column', flexGrow: 1 } },
                    react_1.default.createElement(ModalSlideout_1.ModalSlideoutHeader, { sx: { pb: 1 } },
                        react_1.default.createElement(ModalSlideout_1.ModalSlideoutTitleArea, { titleTypographyVariant: 'h5', title: props.getEntityTitle(data) })),
                    react_1.default.createElement(EntitySlideoutContent_1.EntitySlideoutContent, { response: data, getEntityTitle: props.getEntityTitle, entityDetailsComponent: props.entityDetailsComponent, onEdit: () => navigate(data.id, { state: { back: true } }), onEditForm: props.entityDetailsEditForm
                            ? () => {
                                navigationContext.navigate(() => navigate(data.id + '/edit-form', { state: { preview: false } }));
                            }
                            : undefined, onPreviewForm: props.entityDetailsPreviewForm
                            ? () => {
                                navigationContext.navigate(() => navigate(data.id + '/edit-form', { state: { preview: true } }));
                            }
                            : undefined })))),
            isLoading && !data && react_1.default.createElement(material_1.CircularProgress, null),
            !data && error != null && react_1.default.createElement(PartialError_1.PartialError, { error: error }))));
}
exports.EntitySlideout = EntitySlideout;
